<template>
  <van-tabs line-height="1" shrink>
    <van-tab title="用户注册">
      <van-form class="mt10" ref="form">
        <van-field
          v-model="registInfo.registerName"
          label="手机号/邮箱"
          name="registerName"
          placeholder="手机号/邮箱"
          :rules="[{ required: true, message: '请填写手机号/邮箱' },{ validator:validatePhoneOrEmail, message: '手机号/邮箱格式错误' }]"
        >
          <template #button>
            <van-button type="primary" v-show="isShow" native-type="button" size="small" @click="getCode">{{message}}</van-button>
            <van-button type="primary" v-show="!isShow" native-type="button" size="small">{{message}}</van-button>
          </template>
        </van-field>
        <van-field
          v-model="registInfo.validateCode"
          label="验证码"
          placeholder="验证码"
          :rules="[{ required: true, message: '请填写验证码' }]"
        />
        <van-field
          v-model="registInfo.nickName"
          name="我的昵称"
          label="我的昵称"
          placeholder="我的昵称"
          :rules="[{ required: true, message: '请填写我的昵称' }]"
        />
        <van-field
          v-model="registInfo.language"
          is-link
          readonly
          name="选择语言"
          label="选择语言"
          placeholder="选择语言"
          @click="showLanguagePicker=true"
        />
        <van-field
          v-model="registInfo.password"
          type="password"
          name="设置密码"
          label="设置密码"
          placeholder="设置密码"
          :rules="[{ required: true, message: '请输入密码' },{ pattern:validatePassword, message: '密码至少包含大写字母，小写字母，数字，且不少于8位' }]"
        />
        <van-field
          v-model="registInfo.confirmPassword"
          type="password"
          name="确认密码"
          label="确认密码"
          placeholder="确认密码"
          :rules="[{ required: true, message: '请确认密码' },{ pattern:validatePassword, message: '密码至少包含大写字母，小写字母，数字，且不少于8位' }]"
        />
        <div style="margin: 16px;">
          <van-button block type="info" @click="nextPage">下一步</van-button>
        </div>
      </van-form>
      <van-popup v-model="showLanguagePicker" round position="bottom">
        <van-picker
          show-toolbar
          :columns="languageList"
          @cancel="showLanguagePicker = false"
          @confirm="onConfirm"
        />
      </van-popup>
    </van-tab>
  </van-tabs>
</template>

<script>
  import {validatePhoneOrEmail,validatePassword} from '@/utils/validate'
  import {getValidateCodeApi,checkValidateCodeApi} from '@/api/common'
  export default {
    name: "res1",
    data() {
      return {
        timer: null,
        showLanguagePicker: false,
        message:'获取验证码',
        isShow:true,//是否显示
        registInfo: {
          registerName: '',
          validateCode: '',
          nickName: '',
          language: '',
          password: '',
          confirmPassword: '',
        },
        languageList: [
          {text: '中文', value: '中文'},
          {text: 'English', value: 'English'}
        ],
        validatePhoneOrEmail: validatePhoneOrEmail,
        validatePassword:validatePassword
      }
    },
    mounted() {
    },
    methods: {
      onConfirm(item) {
        this.registInfo.language = item.value;
        this.showLanguagePicker = false;
      },
      //获取手机注册的code值
      getCode() {
        // 局部表单验证
        this.$refs.form.validate('registerName').then(async() => {
          let params = {
            loginName: this.registInfo.registerName
          };
          let response = await getValidateCodeApi(params);
          if (response.success) {
            if (response.code === "0000") {
              const TIME_COUNT = 60;
              if (!this.timer) {
                this.count = TIME_COUNT;
                this.show = false;
                this.timer = setInterval(() => {
                  if (this.count > 0 && this.count <= TIME_COUNT) {
                    this.count--;
                    this.message = '剩余' + this.count + '秒'
                    this.isShow = false
                  } else {
                    this.message = '重新发送';
                    clearInterval(this.timer);
                    this.isShow = true
                    this.timer = null;
                  }
                }, 1000);
              }
              this.$toast.success(response.msg)
            }else {
              this.$toast.fail(response.msg)
            }
          }
        }).catch(() => {
          //this.$toast.fail('验证码获取失败')
        })
      },
      //点击下一步
      nextPage() {
        // 全局表单验证
        this.$refs.form.validate().then(async() => {
          if(this.registInfo.password!==this.registInfo.confirmPassword){
            this.$toast.fail("两次密码不一致");
          }
          else {
            let params = {
              loginName: this.registInfo.registerName,
              validateCode: this.registInfo.validateCode
            };
            let response = await checkValidateCodeApi(params);
            if (response.success) {
              if (response.code === "0000") {
                this.setUserInfo("RegisterInfo", {
                  ...this.registInfo
                });
                //自动触发父组件save事件
                this.$emit('save', this.registInfo)
              } else {
                this.$toast.fail(response.msg);
              }
            }
          }
        }).catch(() => {
          //this.$toast.fail('提交失败')
        })
      }
    }
  }
</script>

<style scoped>
  #con1 {
    margin-right: 8px;
    width: 189px;
  }

  #con2 {
    margin-right: 54px;
    width: 217px;
  }

  #language {
    margin-right: 41px;
    width: 217px;
  }

  #navCon {
    z-index: 1;
  }

  #navCon {
    height: 31.5rem;
  }

  #navCon p {
    height: 3.2rem;
    border-bottom: 1px solid #eff3f9;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-items: center;
  }

  #navCon p span {
    display: block;
    height: 100%;
    width: 5.2rem;
    font-size: 1.3rem;
    line-height: 3.2rem;
    color: #646464;
    border-bottom: 1px solid #5aa4e9;
  }

  #navCon p img {
    width: 1.5rem;
    height: 1.5rem;
  }

  .inCon3 {
    position: relative;
    height: 4.6rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #f6f6f6;
  }

  .inCon3 p {
    font-size: 15px;
    color: black;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    color: #505f6f;

  }

  .inCon3 p:last-child {
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .inCon3 input {
    display: block;
    font-size: 0.13rem;
    color: black;
    height: 100%;
    background: none;
  }

  #navCon .inCon3 img {
    width: 0.12rem;
    height: 0.07rem;
  }

  #navCon .list1 {
    display: flex;
    border-bottom: 1px solid #edf2f9;
    justify-content: space-around;
    align-items: center;
  }

  #navCon .inCon3 #Sendcode {
    display: block;
    width: 0.7rem;
    height: 0.24rem;
    border-radius: 10px;
    background: #09a5bb;
    text-align: center;
    line-height: 0.24rem;
    color: white;
  }

  #navCon .list2 {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    margin-left: -0.02rem;
  }

  #navCon .list2 span {
    margin-left: -0.2rem;
  }

  #navCon .list2 input {
    margin-left: -0.155rem;
  }

  #navCon .list2 a img {
    width: 0.14rem;
    height: 0.07rem;
  }

  #navCon .list3 input {
    margin-left: 0.36rem;
  }

  #navCon li:nth-child(3) span {
    margin-left: 0.11rem;
  }

  #boxCon {
    height: 4.25rem;
    position: absolute;
    margin-top: 0.2rem;
    display: flex;
    flex-direction: column;
    padding: 0 0.1rem;
  }

  #boxCon {
    z-index: 1;
  }

  /*登陆的按钮*/
  .loginBtn {
    height: 0.74rem;
    margin-top: 0.15rem;
    padding-top: 0.15rem;
  }

  /*按钮提交*/
  #btn1 {
    display: block;
    font-size: 16px;
    height: 0.35rem;
    width: 100%;
    border-radius: 6px;
    background: #61a8ea;
    text-align: center;
    line-height: 0.35rem;
  }

  /*点击单选框*/
  .check {
    height: 0.17rem;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    padding-left: 1.35rem;
    font-size: 0.08rem;
    color: #c5cacf;
    margin-top: 0.09rem;
  }

  .check p {
    color: #00a1bb;
  }

  .check a {
    color: #c5cacf;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .p1 {
    margin-right: 0.15rem;
  }

  .check img {
    width: 0.06rem;
    height: 0.11rem;
    margin-left: 0.05rem;
  }
</style>
